import { TOGGLE_COMPONENT } from '../constants/ActionTypes';
import update from 'react/lib/update';

const initialState = {
	'Home': [{
		'name': 'Intro',
		'anchor': '#intro',
		'template': 'Intro',
	}, {
		'name': 'Browser Compatibility',
		'anchor': '#browserCompatibility',
		'template': 'BrowserCompatibility',
	}],
	'Brand': [{
		'name': 'Typography',
		'anchor': '#typography',
		'template': 'Typography',
		'include': true,
	}, {
		'name': 'Colors',
		'anchor': '#colors',
		'template': 'Colors',
		'include': true,
	}, {
		'name': 'Logo',
		'anchor': '#logo',
		'template': 'Logo',
		'include': true,
	}, {
		'name': 'App Icons',
		'anchor': '#appify',
		'template': 'Appify',
		'include': true,
	}],
	'Core': [{
		'name': 'Grid',
		'anchor': '#grid',
		'template': 'Grid',
		'include': true,
	}, {
		'name': 'Forms',
		'anchor': '#forms',
		'template': 'Forms',
		'include': true,
	}, {
		'name': 'Dropzone',
		'anchor': '#dropzone',
		'template': 'Dropzone',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Buttons',
		'anchor': '#buttons',
		'template': 'Buttons',
    	'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Button Dropdowns',
		'anchor': '#button-dropdowns',
		'template': 'ButtonDropdowns',
		'js': true,
		'include': true,
		'optional': true,
  }, {
		'name': 'Filters',
		'anchor': '#filters',
		'template': 'Filters',
		'js': true,
		'include': true,
		'optional': true,
  }, {
		'name': 'Tables',
		'anchor': '#tables',
		'template': 'Tables',
		'js': true,
		'include': true,
		'optional': true,
	},{
		'name': 'Badges',
		'anchor': '#badges',
		'template': 'Badges',
		'include': true,
	}, {
		'name': 'Alerts',
		'anchor': '#alerts',
		'template': 'Alerts',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Toasts',
		'anchor': '#toasts',
		'template': 'Toasts',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Tabs',
		'anchor': '#tabs',
		'template': 'Tabs',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Accordion',
		'anchor': '#accordion',
		'template': 'Accordion',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Wells',
		'anchor': '#wells',
		'template': 'Wells',
		'include': true,
		'optional': true,
	}, {
		'name': 'Tooltips',
		'anchor': '#tooltips',
		'template': 'Tooltips',
		'include': true,
		'optional': true,
	}, {
		'name': 'Countdown Timer',
		'anchor': '#countdown-timer',
		'template': 'CountdownTimer',
		'include': true,
		'optional': true,
	}, {
		'name': 'Modals',
		'anchor': '#modals',
		'template': 'Modals',
		'js': true,
		'include': true,
		'optional': true,
	},  {
		'name': 'Drawers',
		'anchor': '#drawers',
		'template': 'Drawers',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Pagination',
		'anchor': '#pagination',
		'template': 'Pagination',
		'include': true,
		'optional': true,
	}, {
		'name': 'Panels',
		'anchor': '#panels',
		'template': 'Panels',
		'include': true,
		'optional': true,
	}, {
		'name': 'Split Layout',
		'anchor': '#splitpanel',
		'template': 'SplitPanel',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Dismissable Sidebar Panel',
		'anchor': '#dismissablesidebarpanel',
		'template': 'DismissableSidebarPanel',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Navigation',
		'anchor': '#navigation',
		'template': 'Nav',
		'include': true,
		'js': true,
  }, {
		'name': 'Search',
		'anchor': '#search',
		'template': 'Search',
		'include': true,
		'js': true,
  }, {
		'name': 'Cards',
		'anchor': '#cards',
		'template': 'Cards',
		'include': true,
	}, {
		'name': 'Toggles',
		'anchor': '#toggles',
		'template': 'Toggles',
		'include': true,
	}, {
		'name': 'Wizard',
		'anchor': '#wizard',
		'template': 'Wizard',
		'include': true,
	}, {
		'name': 'Loaders',
		'anchor': '#loaders',
		'template': 'Loaders',
		'include': true,
		'optional': true,
	}, {
		'name': 'Icons',
		'anchor': '#icons',
		'template': 'Icons',
		'include': true,
		'optional': true,
	}, {
		'name': 'Helpers',
		'anchor': '#helpers',
		'template': 'Helpers',
		'include': true,
		'optional': false,
	}, {
		'name': 'Breakpoints',
		'anchor': '#breakpoints',
		'template': 'Breakpoints',
		'include': true,
		'optional': false,
	}],
	'Components': [{
		'name': 'Date Picker',
		'anchor': '#datepicker',
		'template': 'Datepicker',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Callouts',
		'anchor': '#callouts',
		'template': 'Callouts',
		'include': true,
		'optional': true,
	}, {
		'name': 'Media Objects',
		'anchor': '#mediaobjects',
		'template': 'Media',
		'include': true,
		'optional': true,
	}, {
		'name': 'Carousel',
		'anchor': '#carousel',
		'template': 'Carousel',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Price Tick',
		'anchor': '#pricetick',
		'template': 'Tick',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Back to Top',
		'anchor': '#backToTop',
		'template': 'BackToTop',
		'include': true,
		'optional': false,
	}, {
		'name': 'Breadcrumb',
		'anchor': '#breadcrumb',
		'template': 'Breadcrumb',
		'include': true,
		'optional': true,
	}, {
		'name': 'Progress Indicators',
		'anchor': '#progress',
		'template': 'Progress',
		'include': true,
		'optional': true,
	}, {
		'name': 'DataTables',
		'anchor': '#datatables',
		'template': 'DataTables',
		'js': true,
		'include': true,
		'optional': true,
	}, {
		'name': 'Environment Banners',
		'anchor': '#environmentbanners',
		'template': 'EnvironmentBanners',
		'include': true,
		'optional': true,
	}],
	'Layouts': [{
		'name': 'Grid Showcase',
		'anchor': '#grid',
		'template': 'LayoutsGrid',
	}, {
		'name': 'Marketing',
		'anchor': '#marketing',
		'template': 'LayoutsMarketing',
	}, {
		'name': 'EREP',
		'anchor': '#erep',
		'template': 'LayoutsEREP',
	}, {
		'name': 'Core UI',
		'anchor': '#core-ui',
		'template': 'LayoutsCoreUI',
	}, {
		'name': 'Sign In Page',
		'anchor': '#signin',
		'template': 'LayoutsSignIn',
	}, {
		'name': 'Update Browser',
		'anchor': '#updatebrowser',
		'template': 'LayoutsUpdateBrowser',
	}, {
		'name': 'Error Pages',
		'anchor': '#errors',
		'template': 'LayoutsErrors',
  }],
  'Themes': [{
    'name': 'Components Showcase',
		'anchor': '#componentsShowcase',
		'template': 'ComponentsShowcase',
	}, {
    'name': 'AG-Grid',
		'anchor': '#agGrid',
		'template': 'AgGrid',
  }],
	'Getting Started': [{
		'name': 'Installation',
		'anchor': '#installation',
		'template': 'Installation',
	}, {
    'name': 'Dark Theme',
		'anchor': '#darkTheme',
		'template': 'DarkTheme',
	}, {
		'name': 'Support',
		'anchor': '#support',
		'template': 'Support',
    'includeStatic': false
	}, {
		'name': 'Change Log',
		'anchor': '#changelog',
		'template': 'ChangeLog',
	}, {
		'name': 'Build',
		'anchor': '#build',
		'template': 'BuildDetail',
    'includeStatic': false
	}]
};

export default function components(state = initialState, action) {

  switch (action.type) {
    case TOGGLE_COMPONENT:
			var newState = update(state, {
				[action.component]: {
					[action.index]: {
						include: {
							$set: state[action.component][action.index].include ? false : true
						}
					}
				}
			})
			return newState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./styleguide/reducers/components.js